<template>
    <!-- 我的活动 -->
    <div class="wid-12">
        <div class="box-shadow pad-1" style="" v-show="$route.meta.showFather">
            <div class="boc-tab">
                <el-tabs v-model="activeName" tab-position="top" @tab-click="handleClick">
                    <el-tab-pane label="待参加" name="0"></el-tab-pane>
                    <el-tab-pane label="进行中" name="1"></el-tab-pane>
                    <el-tab-pane label="已结束" name="2"></el-tab-pane>
                </el-tabs>
                <div class="searvhs" @click="searchs">
                    <div class="flex-1 se-1">
                        <img src="../../../assets/myself/sousuo.png" alt="">
                        <p>搜索您的活动</p>
                    </div>
                </div>
            </div>
            <div class="flex-1 cursor mt-32"  v-for="(item,index) in expertList"
                :key="index">
                <div class="tttile" @click="detail(item.id)">
                    <img :src="item.coverImage" alt="" class="hed-img">
                    <p :class="item.activityStatus==1000?'first-1':item.activityStatus==2000?'first-2':'first-3'" class="first">
                        {{item.activityStatus==1000?'待参加':item.activityStatus==2000?'进行中':'已结束'}}
                    </p>
                </div>
                <div style="padding-right: 48px;width: 450px;">
                    <div class="flex-1 just-bet mb-8">
                        <p class="name-1">{{item.name}}</p>
                    </div>
                    <div class="flex-1 just-bet mb-8" style="align-items: baseline;">
                        <p class="name-2">培训简介:</p>
                        <p class="name-3">
                            {{item.intro}}
                        </p>
                    </div>
                    <div class="flex-1 just-bet" style="margin-bottom: 22px;">
                        <p class="name-2">培训时间:</p>
                        <p class="name-3">
                             {{utils.getNowTime(item.startTime)}}-{{utils.getNowTime(item.endTime)}}
                        </p>
                    </div>
                </div>
                <div class="mt-23" @click="info(item.id)">
                    <div class="online">
                        报名信息
                    </div>
                </div>
            </div>
            <el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
                layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
            </el-pagination>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getMyActivity,
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                activeName: '',
                expertList: [],
                currentPage4: 4,
                page: 1,
                limit: this.pageGroup.size,
                //分页对象
                pageInline: {
                    tableSizes: this.pageGroup.sizes, //显示条数分组
                    tableTotal: 10, // 默认数据总数
                },
            }

        },
        watch: {
            '$store.state.activity.activeTab'(newVal, oldVal) {
                this.activeName = newVal;
				this.getInit()
				this.$store.commit('saveActiveTab', newVal)
            }
        },
        created() {
            // this.activeName = this.$store.state.activity.activeTab;
            // let tabs = this.$route.params.tab;
            // console.log(this.activeName, '接收参数')
            // this.activeName = tabs 
        },
        mounted() {
            this.getInit();
        },
        methods: {
            getInit() {
                let params = {
                    pageNo: this.page,
                    pageSize: this.pageGroup.size,
                    activityStatus:this.activeName == 0?'1000':this.activeName,
                }
                getMyActivity(params).then(res => {
                        this.expertList = res.data.list;
                        this.pageInline.tableTotal = res.data.total;
                    })
                    .catch(error => {
						
                    });
            },
            handleClick(tab, event) {
                if(tab.index == 0){
                    this.activeName = 1000;
                }else if(tab.index == 1){
                    this.activeName = 2000;
                }else{
                    this.activeName = 3000;
                }
                // this.activeName = tab.index
                
                console.log(this.activeName,'index')
                this.getInit()
                this.$store.commit('saveActiveTab', tab.index)
            },
            //页容量改变时会触发
            handleSizeChange(size) {
                this.limit = size;
                this.getInit();
            },
            //当前页改变时会触发
            handleCurrentChange(currentPage) {
                console.log(currentPage,'currentPage')
                this.page = currentPage;
                this.getInit();
            },
            detail(id) {
            	this.$router.push({
            		name: 'activityDetail',
            		params: {
            			id: id,
						footersType:1,
            		}
            	})
            },
            info(ids){
                console.log(ids,'--')
                this.$router.push({
                    name:'/activity/information',
                    params:{
                        id:ids,
						footersType:1,
                    }
                })
            },
            
            searchs(){
                this.$router.push({
                    name:'/activity/searchActivity',
                    params:{
                        types:1,
						footersType:1,
                    }
                })
                // this.$router.push('/personal/activity/searchActivity')
            }
        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-1 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    /deep/.boc-tab .el-tabs__item {
        color: #222222;
        font-size: 14px;
        width: 34%;
        padding-right: 0;
    }

    /deep/.boc-tab .el-tabs__item .is-top .is-active {
        /* color: #3377FF; */
        /* background-color: #ffffff; */
    }

    /deep/.boc-tab .el-tabs__item .is-active {
        color: #3377FF !important;
        background-color: #ffffff !important;
    }

    /deep/.el-tabs__item.is-active {
        color: #3377FF !important;
    }

    /deep/.boc-tab .el-tabs__active-bar {
        width: 34% !important;
        bottom: 13%;
        background-color: #3377FF !important;
        /* transform:none!important; */
    }

    /deep/.boc-tab .el-tabs__nav-scroll {
        padding-left: 0;
        border-bottom: 1px solid #EFEFEF;
        height: 48px;
    }

    /deep/.boc-tab .el-tabs {
        width: 75%;
    }

    .boc-tab {
        position: relative;
    }

    .searvhs {
        position: absolute;
        right: 1rem;
        top: 10px;
    }

    .se-1 {
        border-radius: 51px 51px 51px 51px;
        border: 1px solid #EFEFEF;
        padding: 0.625rem 1rem;
        cursor: pointer;
    }

    .se-1 img {
        width: 1.125rem;
        height: 1.1875rem;
        padding-right: 0.625rem;
    }

    .se-1 p {
        font-size: 14px;
        color: #CCCCCC;
    }

    .tttile {
        position: relative;
    }

    .hed-img {
        width: 280px;
        height: 160px;
        padding-right: 16px;
    }

    .mb-8 {
        margin-bottom: 8px;
    }

    .name-1 {
        font-size: 20px;
        padding-right: 9px;
        padding-top: 35px;
    }

    .name-2 {
        color: #999999;
        font-size: 14px;
        white-space: nowrap;
        padding-right: 8px;
    }

    .name-3 {
        font-size: 14px;
        font-weight: normal;
    }

    /deep/.el-pagination {
        text-align: center;
    }

    .online {
        font-size: 14px;
        color: #3377FF;
        padding: 8px 16px;
        background: #F0F5FF;
        white-space: nowrap;
        border-radius: 35px 35px 35px 35px;
    }

    .mt-32 {
        margin-top: 32px;
    }
    .first{
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        font-weight: normal;
        border-radius: 4px 16px 4px 16px;
        padding: 4px 16px;
    }
    .first-1 {
        color: #FBB54C;
        background: #FFF6F0;
    }
    .first-2 {
        color: #3ECC64;
        background: #EBFAEF;
    }
    .first-3 {
        color: #FF534D;
        background: #FFF0F0;
    }
</style>
